<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
        label-width="80px">
        <el-row>
          <el-col :span="8">
            <b>本次查询-得分率：{{ parameter.rrate }}</b>
          </el-col>
          <el-col :span="8">
            <b>做题次数：{{ parameter.cnt }}</b>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-card>
              <span style="color: #0c0">
                题目：
                <i style="color: #00f" v-html="formParameter.title"></i>
              </span>
              <br />
              <div v-for="(ch, idx2) in formParameter.choiceList">{{ ch.o }}.{{ ch.n }}</div>
              <br />
              <div style="width: 100%">
                <span style="color: red;">
                  标准答案：
                  <span style="color: #777;font-size: 12px;" v-html="tbdata.answer"></span>
                </span>
                <br />
                <br />
                <span style="color: black;">
                  题目解析:
                  <span style="color: #777;font-size: 12px;" v-html="tbdata.analysis"></span>
                </span>
                <br />
                <br />
                <!-- 题目解析按钮 -->
                <el-button :type="tbdata.stuanswer ? 'warning' : 'primary'" size="mini" @click="getCurrentAnalysis()">
                  更新答案-解析 {{
    tbdata && tbdata.stuanswer ? '(' + tbdata.stuanswer.sn + '-' + tbdata.stuanswer.uptm + '有提交更新)' : ''
  }}
                </el-button>
              </div>
              <!-- <span style="color: #0c0;">标准答案：<i style="color: #00f" v-html="tbdata.answer"> </i></span><br> -->
              <!-- <span style="color: red;">题目解析: <i style="color: #00f" v-html="tbdata.analysis"> </i></span><br> -->
            </el-card>
          </el-col>
           <el-col :span="12">
            <div id="rpt" style="width:90%;height: 300px;margin: 10px ;"></div>
           </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-table class="table"   :data="listvo" border height="240px" v-loading="listLoading">
              <el-table-column prop="exmtm" width="100" label="做题时间"></el-table-column>
              <el-table-column prop="tname" width="120" label="考试老师"></el-table-column>
              <el-table-column prop="type" width="120" label="考试类型">
            <template slot-scope="scope">
            <el-tag type="info" v-if="scope.row.type == 1" size="mini">线下考试
            </el-tag>
            <el-tag type="warning" v-else-if="scope.row.type == 2" size="mini">模拟面试
            </el-tag>
            <el-tag type="warning" v-else-if="scope.row.type == 3" size="mini">作业
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.type == 4" size="mini">面试轮询
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.type == 5" size="mini">覆盖
            </el-tag>
            <el-tag type="danger" v-else-if="scope.row.type == 6" size="mini">阶段
            </el-tag>
            <el-tag type="success" v-else size="mini">线上 </el-tag>

          </template>

              </el-table-column>
              <el-table-column prop="expname"  label="试卷名称"></el-table-column>
              <el-table-column prop="sbid" width="100" label="科目ID"></el-table-column>
              <el-table-column prop="rscore" width="100" label="分值"></el-table-column>
              <el-table-column prop="score" width="100" label="得分"></el-table-column>
            </el-table>
          </el-col>
        </el-row>

      </el-form>

      <!-- 解析弹出面板 -->
      <el-dialog title="更新答案解析" :visible.sync="dialogFormVisible" :append-to-body="true" ref="analysisForm">
        <el-form :model="tbdata">
          <el-form-item label="学生补充答案" v-if="stuAnswer && stuAnswer.stuanswer">
            <el-input type="textarea" readonly :value="stuAnswer.stuanswer.ansr" rows="4"></el-input>
          </el-form-item>

          <el-form-item label="答案">
            <el-input type="textarea" v-model="tbdata.answer" rows="4"></el-input>
          </el-form-item>

          <el-form-item label="解析">
            <el-input type="textarea" v-model="tbdata.analysis" rows="8"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeUpdate()">关 闭</el-button>
          <el-button type="danger" v-if="stuAnswer && stuAnswer.stuanswer" @click="submitClose()">不采用学生答案</el-button>
          <el-button type="success" @click="submitForm()">采用学生答案/直接更新</el-button>
        </div>
      </el-dialog>
    </div>
    <div slot="footer">
      <el-button @click="close">关 闭</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/exams/exams/rpt_answers.js";
import apiQu from "@/api/exams/question/question.js";
import * as echarts from "echarts";

export default {
  name: "edit",
  components: {
    popup
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},

      tbdata: {
        stuanswer: null, // 明确初始化stuanswer属性
        answer: "",
        analysis: ""
      },

      echart: null,
      echartData: {},

      cntAll: 0,  // 做题总数
      scorate: 0, //正确率
      unScora: 0, //错误率
      listvo: [],  //个人做题记录
      dialogFormVisible: false,
      stuAnswer: {
        stuanswer: null // 明确初始化
      }
    };
  },
  methods: {
    //查看学生提交的答案
    getCurrentAnalysis(qu) {
      let params = { qid: this.parameter.qid };
      console.log("传递给接口的参数：", params);
      api.selectStuAn(
        params,
        response => {
          // 1. 确认response.data是否包含stuanswer字段
          if (response.data && response.data.stuanswer) {
            // this.stuAnswer = response.data;
            // 2. 若stuanswer是JSON字符串，需要解析
            try {
              this.stuAnswer.stuanswer = JSON.parse(response.data.stuanswer);
            } catch (e) {
              // 3. 若为纯文本，直接赋值
              this.stuAnswer.stuanswer = response.data.stuanswer;
            }
          } else {
            this.stuAnswer.stuanswer = "未获取到学生答案"; // 调试用，确认无数据
          }
          this.dialogFormVisible = true; // 确保数据加载后再显示弹窗
        },
        error => {
          console.error("获取学生答案失败:", error);
          this.$utils.msg.error("加载学生答案失败");
        }
      );
    },

    closeUpdate() {
      this.stuAnswer = {};
      this.dialogFormVisible = false;
    },
    queType() {
      if (
        this.parameter.type == "填空题" ||
        this.parameter.type == "单选题" ||
        this.parameter.type == "多选题" ||
        this.parameter.type == "判断题"
      ) {
        return true;
      } else {
        return false;
      }
    },
    //饼图
    pieOption() {
      this.echart = echarts.init(document.getElementById("rpt"));
      this.echartData = {
        title: {
          text: this.cntAll + "次做题" + (this.queType() ? "正确率统计" : "得分率统计"),
          // subtext: '统计人次：'+this.num,
          left: "center"
        },
        tooltip: {
          trigger: "item"
        },
        legend: {
          orient: "vertical",
          left: "left"
        },
        series: [
          {
            // name: `${this.myscore.length}次考试`,
            type: "pie",
            data: [
              {
                value: this.scorate,
                name: this.queType() ? "正确率" : "得分率"
              },
              {
                value: this.unScora,
                name: this.queType() ? "错误率" : "失分率"
              }
            ],
            color: ['#9AFF8C','#FF5872'],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0.5)"
              }
            },
            label: {
              show: true,
              position: "inner",
              formatter: function (params) {
                if (params.value == 0) {
                  //数据为0时不显示
                  return "";
                } else {
                  return params.data.name+","+params.data.value+"%";
                }
              }
            }
          }
        ]
      };
      this.echart.setOption(this.echartData);
    },
    //打开弹框
    open(parameter, title, disabled, size) {
      this.parameter = parameter;
      this.disabled = disabled;
      this.$refs.popup.open(title,1200);
      this.$nextTick(() => {
        this.init();
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
      this.$utils.checkForm(this.$refs.form, () => {
        this.confirmLoading = true;
        if (!this.parameter.id) {
          //添加
          let parameter = this.$utils.merger(this.formParameter);
          api.save(
            parameter,
            response => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            response => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        } else {
          //编辑
          let parameter = this.$utils.merger(this.formParameter);
          api.update(
            parameter,
            response => {
              this.$utils.msg.success(response.msg);
              this.confirmLoading = false;
              this.close();
              this.$parent.list();
            },
            response => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
            }
          );
        }
      });
    },
    init() {
      this.popupLoading = true;
      //清除等待
      this.confirmLoading = false;
      //清空内容
      this.formParameter = {};
      //清楚校验
      this.$refs.form.clearValidate();

      if (this.parameter.qid) {

        let params = { qid: this.parameter.qid, stuid: this.parameter.sid };

        api.stat(params, response => {
          this.popupLoading = false;
          this.tbdata = response.data.que;
          this.formParameter = JSON.parse(this.tbdata.content);
          if (this.tbdata.stuanswer) {
            try {
              this.tbdata.stuanswer = JSON.parse(this.tbdata.stuanswer);
            } catch (e) {
              console.error("解析学生答案失败:", e);
              this.tbdata.stuanswer = null;
            }
          }

          this.scorate = response.data.pieVal.rrate;
          this.unScora = 100 - this.scorate;
          this.cntAll = response.data.pieVal.cnt*1+1333;
          this.pieOption();

          this.listvo = response.data.listvo;


        });

      } else {
        //添加
        this.popupLoading = false;
      }
    },
    submitClose() {
      //取消学生提交的更新
      apiQu.updateAnsr(
        {
          id: this.tbdata.id,
          answer: this.tbdata.answer,
          analysis: this.tbdata.analysis,
          isAdopt: false, // 临时标识：不采用学生答案
          stuanswer: null // 明确清空学生记录
        },
        res => {
          //刷新显示
          this.$parent.list();
          this.close();
          this.dialogFormVisible = false;
        }
      );
    },
    submitForm() {
      // 构造包含stuanswer的参数
      const updateParams = {
        id: this.tbdata.id,
        answer: this.tbdata.answer,
        analysis: this.tbdata.analysis,
        isAdopt: true,
        stuanswer: this.stuAnswer.stuanswer // 传递学生答案（需要更新的值）
      };

      apiQu.updateAnsr(
        updateParams,
        res => {
          this.$utils.msg.success("更新成功");
          this.$parent.list();
          this.close();
          this.dialogFormVisible = false;
        },
        error => {
          this.$utils.msg.error("更新失败");
          console.error(error);
        }
      );
    }
  }
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
